'use strict';

angular.module('docketbook').
  controller('preAuthDocketController', function (docketService, $rootScope, $cookies, $scope, $state, $stateParams, $http, Restangular, accessControl, $q) {
    mixpanel.track("Opened Preauth Docket Desktop");

    $scope.currentUser = accessControl.currentUser();

    $scope.moment = moment;
    $scope.docketId = $stateParams.docketId;
    $scope.fullApiPath = DOCKETBOOK_API_URL + "/" + $scope.urlVersion;
    $scope.isPreAuthDocket = true;

    $scope.openDocket = function (docket) {
      $scope.isPreAuthDocket = true;
      $scope.loadDocketFromParent(docket, 0, false);
    }

    $scope.loadDocket = function () {
      if ($scope.docketId) {
        docketService.getDocket($scope.docketId, null, function (fullDocket) {
          $scope.docket = fullDocket;
          $scope.itemEdit = fullDocket;
          $scope.itemEdit.editing = true;

          if ($scope.itemEdit.startTime && $scope.itemEdit.endTime) {
            var totalMinutes = parseInt(moment($scope.itemEdit.endTime).diff(moment($scope.itemEdit.startTime), 'minutes'))

            if ($scope.itemEdit.breakTime) {
              totalMinutes = totalMinutes - $scope.itemEdit.breakTime
            }
            if ($scope.itemEdit.travelTime) {
              totalMinutes = totalMinutes + $scope.itemEdit.travelTime
            }

            $scope.itemEdit.totalTime = (totalMinutes / 60).toFixed(2) + ' Hrs';
          }

          if ($scope.itemEdit.templateValueStore) {
            var templateStoreValues = Object.values($scope.itemEdit.templateValueStore);
            $scope.signatureAttachments = $scope.itemEdit.attachments.reduce((acc, attachment) => {
              if (templateStoreValues.indexOf(attachment.id) !== -1) {
                acc.push(attachment.id);
              }
              return acc;
            }, []);
          }

          var resourceCount = $scope.itemEdit.resources.length;
          $scope.itemEdit.resources.forEach(function (item) {
            if (resourceCount <= 2) {
              item.collapsed = false;
            } else {
              item.collapsed = true;
            }
          });
          var attachmentsCount = 0;
          if ($scope.itemEdit.attachments) {
            for (var i = 0; i < $scope.itemEdit.attachments.length; i++) {
              if ($scope.itemEdit.attachments[i].fileName != 'supplier-signature' && $scope.itemEdit.attachments[i].fileName != 'customer-signature') {
                attachmentsCount += 1;
              }
            }
          }
          $scope.itemEdit.attachmentCount = attachmentsCount;
          if ($scope.currentOrg != null && $scope.currentOrgGroup != null && accessControl.userHasPermission('io.docketbook.ojdapi.fileDockets')) {
            $scope.setupFilingDetails($scope.itemEdit);
          }
          //$scope.setupAuditLog($scope.itemEdit);
          $scope.itemEdit.signatureFields = {};

          // Check permissions for this anon users and customer signature
          if (!$scope.docket.customerSignature && $scope.docket.template && $scope.docket.template.blocks.map(function (block) { return block.type }).includes('signatures')) {
            var hasApproverRole = false;
            for (var i = 0; i < $scope.currentUser.emailAddresses.length; i++) {
              if (
                $scope.docket.accessControl[$scope.currentUser.emailAddresses[i]].indexOf('approver') != -1
                || $scope.docket.accessControl[$scope.currentUser.emailAddresses[i]].indexOf('editor') != -1
              ) {
                hasApproverRole = true;
              }
            }
            if (hasApproverRole) {
              $scope.docket.askForSignature = true;
            }
          }

          if ($scope.docket.template && $scope.docket.template.attachments) {
            $scope.docket.hasTermsConditions = false;
            $scope.docket.termsAttachments = [];
            for (var i = 0; i < $scope.docket.template.attachments.length; i++) {
              if ($scope.docket.template.attachments[i].type == 'termsConditions') {
                $scope.docket.hasTermsConditions = true;
                $scope.docket.termsAttachments.push($scope.docket.template.attachments[i]);
              }
            }
          }
        }, function (err) {
          alert('error loading this docket');
        });
      }
    }

    $scope.loadDocket();

    $scope.openDocketTermsAttachments = function () {
      for (var i = 0; i < $scope.docket.termsAttachments.length; i++) {
        window.open(DOCKETBOOK_API_URL + '/' + $scope.urlVersion + '/dockets/' + $scope.docket.id + '/template/attachment/' + $scope.docket.termsAttachments[i].id);
      }
    }

    $scope.captureSignatureForDocket = function (entity, nameRequired, name, terms, template, cb) {
      $scope.captureSignatureCallback = cb;
      $scope.captureSignatureFromParent(entity, nameRequired, name, terms, template, function (signatureObject) {
        $scope.captureSignatureCallback(signatureObject);
      });
    }

    $scope.getCustomerSignature = function () {
      $scope.captureSignatureForDocket('customerSignature', true, "", true, $scope.itemEdit.template, function (signatureObject) {
        $scope.itemEdit.customerSignatureData = signatureObject.signatureImage;
        $scope.itemEdit.customerSignatureImage = signatureObject.signatureImageFull;
        $scope.itemEdit.customerSignatureName = signatureObject.signatureName;
        $scope.uploadSignature($scope.itemEdit, function () {
          $scope.docket.askForSignature = false;
          $scope.loadDocket();
        }, function () {
          alert('error uploading sig');
        });
      });
    }

    $scope.uploadSignature = function (docket, successCb, failureCb) {
      var signatureImage = docket.customerSignatureData;
      var filename = 'customer-signature';
      var url = DOCKETBOOK_API_URL + '/' + $rootScope.urlVersion + "/dockets/" + docket.id + "/attachment";
      var body = '--__TEST123__\r\ncontent-disposition: form-data; name="file"; filename="' + filename + '"\r\ncontent-type: image/png\r\nContent-Transfer-Encoding: base64\r\n\r\n' + signatureImage + '\r\n';
      body += "--__TEST123__";
      if (docket.customerSignatureName) {
        body += "\r\n";
        body += 'content-disposition: form-data; name="jsondata";filename="customername.json"\r\ncontent-type: application/json\r\n\r\n{"customerSignatureName":"' + docket.customerSignatureName + '"}\r\n--__TEST123__--\r\n';
      } else {
        body += "--";
      }
      var header = 'multipart/form-data; boundary="__TEST123__"';
      $http.put(url, body, {
        headers: { 'Content-Type': header },
        withCredentials: true,
      }).then(function () {
        successCb();
        return;
      }, function (err) {
        failureCb();
        return;
      })
    }

    $scope.downloadDocket = function () {
      var url = '/v1/dockets/' + $scope.docketId + '/downloadpdf';
      window.open(url, "_blank");
    }

    $scope.login = function () {
      $cookies.remove('dbtoken');
      window.location = '/v1/logout';
    }

    /* Docket Detail Helpers */
    $scope.getResourceQtySummary = function (resourceGrouped) {
      var totalQuantity = 0;
      for (var i = 0; i < resourceGrouped.interactions.length; i++) {
        if ($scope.itemEdit.template.sumOnlyBillableInteractions) {
          if (resourceGrouped.interactions[i].interactionTemplate.billable) {
            totalQuantity += resourceGrouped.interactions[i].quantity;
          }
        } else {
          totalQuantity += resourceGrouped.interactions[i].quantity;
        }
      }

      totalQuantity = totalQuantity.toFixed(2);

      return totalQuantity + " " + resourceGrouped.resource.uom.abbreviation;
    }

  });



// WEBPACK FOOTER //
// ./src/controllers/preauth/preAuthDocketController.js